import { luscinia } from "./luscinia";

luscinia.initUpdateJobOverview = function (filter?: JQuery<HTMLElement>) {
    let jobOverviews: JQuery<HTMLElement>;
    let isRenderStatusRunOnce: boolean = false;
    let isRenderStatusForChildRunOnce: boolean = false;
    if (filter !== null && filter !== undefined) {
        jobOverviews = $(filter).find(".joboverview.update");
    }
    else {
        jobOverviews = $(".joboverview.update");
    }
    jobOverviews.each(function (index, element) {
        var lastUtcTime = new Date().toUTCString();
        var jobRunId = $(element).attr("logId");
        var updateJobOverview = function () {
            var jobBanner = $(element).find(".jobbanner");
            var statusName = jobBanner.attr("statusName");
            $.post("/data/jobruns/renderjobbanner", { jobRunId: jobRunId, statusName: statusName }, function (data) {
                if (data !== null && data !== undefined && data !== "") {
                    jobBanner.replaceWith(data);
                }
            }).then(function () {
                $.get(`/data/jobruns/statuspercentages?id=${jobRunId}`,
                    function (percentagesList: { name: string; percentage: number; }[]) {
                        var totalPercentage = 0;
                        for (var obj of percentagesList) {
                            var panelElement = $(element).find(`[id='${obj.name.replace(/ /g, "")}']`);
                            var progressBar = panelElement.find(".progress-bar");
                            progressBar.attr("style", `width: ${obj.percentage.toString()}%`);
                            var newProgressContent = obj.percentage.toLocaleString() + "%";
                            if (progressBar.html() !== newProgressContent) {
                                progressBar.html(newProgressContent);
                            }
                            totalPercentage += obj.percentage;
                        };
                        var totalProgressBar = $(element).find(".totalprogressbar");
                        if (totalProgressBar.length > 0) {
                            var totalProgress = totalPercentage / percentagesList.length;
                            totalProgressBar.attr("style", `width: ${totalProgress.toString()}%`);
                            var newProgressContent = totalProgress.toLocaleString() + "%";
                            if (totalProgressBar.html() !== newProgressContent) {
                                totalProgressBar.html(newProgressContent);
                            }
                        }
                    }
                ).then(function () {
                    var shouldUpdateMessages = true;
                    $.post("/data/jobruns/statuses", { jobRunId: jobRunId }, function (statuses: string[]) {
                        var statusPanelsRendered = 0;
                        var statusPanelsRequiringRender = 0;
                        var statusNames: string[] = [];
                        for (var status of statuses) {
                            var panelElement = $(element).find(`[id='${status.replace(/ /g, "")}']`);
                            if (panelElement.length == 0) {
                                shouldUpdateMessages = false;
                                statusPanelsRequiringRender++;
                                statusNames.push(status);
                            }
                        }
                        if (statusNames.length > 0) {
                            $.post('/data/jobruns/renderstatuspanels', { jobRunId: jobRunId, collapseIndex: $(element).find('.panel').length - 1, statusNames: statusNames }, function (data: Panel) {
                                if (data.hasChildJob) {
                                    if (isRenderStatusForChildRunOnce === true) return;
                                    isRenderStatusForChildRunOnce = true;
                                    $(element).find('.panel-group').append(data.content);
                                    statusPanelsRendered++;
                                }
                                else {
                                    if (isRenderStatusRunOnce === true) return;
                                    isRenderStatusRunOnce = true;
                                    $(element).find('.panel-group').append(data.content);
                                    statusPanelsRendered++;
                                }
                            }).then(function () {
                                if (statusPanelsRequiringRender === statusPanelsRendered) {
                                    updateMessages();
                                }
                            });
                        }
                    }).then(function () {
                        if (shouldUpdateMessages) {
                            updateMessages();
                        }
                    });
                });
            });

            var updateMessages = function () {
                $.post("/data/jobruns/statusmessages", { logId: jobRunId, dateSince: lastUtcTime },
                    function (messageObjects: { id: string; name: string; html: string; logType: number; }[]) {
                        for (var messageObject of messageObjects) {
                            var panelElement = $(element).find(`[id='${messageObject.name.replace(/ /g, "")}']`);
                            if (panelElement.length == 0) {
                                console.error("Could not find the statuspanel " + messageObject.name + " failed to log message.")
                            } else {
                                updatePanelWithMessage(panelElement, messageObject);
                            }
                        }
                    }
                );
                lastUtcTime = new Date().toUTCString();
            };

            const logTypeOrder = [3, 2, 1, 0, 5, 4];
            var updatePanelWithMessage = function (panelElement: JQuery<HTMLElement>, messageObject: { id: string; name: string; html: string; logType: number; }) {
                var panelBody = panelElement.find(".panel-body");
                var iconClass = "";

                switch (messageObject.logType) {
                    case 0: // Error
                        iconClass = "errorIcon";
                        break;
                    case 1: // Warning
                        iconClass = "warningIcon";
                        break;
                    case 2: // Info
                        iconClass = "infoIcon";
                        break;
                    case 3: // Success
                        iconClass = "successIcon";
                        break;
                    case 4: // Awaiting
                        iconClass = "awaitingIcon";
                        break;
                    case 5: // Running
                        iconClass = "runningIcon";
                        break;
                }
                var newStatusMessage = messageObject.html;
                var $StatusMessage = $(`.statusmessage[id="${messageObject.id}"]`);
                if ($StatusMessage.length === 0) {
                    //Update Icon
                    var countElement = panelElement.find("." + iconClass);
                    var newCount = parseInt(countElement.html()) + 1;
                    countElement.html(newCount.toString());
                    countElement.show();
                    panelElement.find(".fa.fa-angle-right").show();

                    panelBody.append(newStatusMessage);
                }
                else if ($StatusMessage.attr("statusType") !== messageObject.logType.toString()) {
                    $StatusMessage.remove();

                    const statusMessageOrder = logTypeOrder.indexOf(messageObject.logType);
                    let statusMessageToInsertAfter: JQuery<HTMLElement>;

                    for (let i = statusMessageOrder; i >= 0; i--) {
                        statusMessageToInsertAfter = panelBody.find(`.statusmessage[statusType=${logTypeOrder[i]}]`).last();
                        if (statusMessageToInsertAfter.length !== 0) {
                            break;
                        }
                    }

                    if (statusMessageToInsertAfter.length === 0) {
                        panelBody.prepend(newStatusMessage);
                    } else {
                        statusMessageToInsertAfter.after(newStatusMessage);
                    }
                }
            };
           setTimeout(updateJobOverview, 2000);
        };

        updateJobOverview();
    });
};

luscinia.reRunJob = function (title: string, text: string, jobRunId: string) {
    luscinia.showConfirmationDialog(title, text, function (e: any) {
        if ($(e.target).data('luscinia-value') === true) {
            luscinia.closeModal();
            $.post(`/data/jobruns/rerunJob/${jobRunId}`).then(() => {
                const path = window.location.pathname;
                if (path !== "/sales-create-invoices-wizard") {
                    pollForRerunStatusUpdate()   
                }
            });

            function pollForRerunStatusUpdate() {
                $.post("/data/jobruns/rerunstatus", { logId: jobRunId}, function (data: ReRunStatus) {
                    $(`#${jobRunId}.statusmessage`).replaceWith(data.html);
                    if (data.isFinished === false) {
                        setTimeout(pollForRerunStatusUpdate, 2000);
                    }
                });
            }
        }
    });
};

interface ReRunStatus {
    html: string;
    isFinished: boolean;
}
class Panel {
    content: string;
    hasChildJob: boolean;
}